import React, { useState, useRef, useEffect } from "react";
import { Grid, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import logo from "../../Recursos/logo.svg";
import IcecreamRoundedIcon from '@mui/icons-material/IcecreamRounded';
import LunchDiningRoundedIcon from '@mui/icons-material/LunchDiningRounded';
import LocalBarRoundedIcon from '@mui/icons-material/LocalBarRounded';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import { Helmet } from "react-helmet";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase/firebase";

const BarraPc = () => {
    const [pos, setPos] = useState({ left: 0, width: 0 });
    const [anchorEl, setAnchorEl] = useState(null);
    const [textos, setTextos] = useState({});
    const location = useLocation();

    const comidasRef = useRef(null);
    const heladosRef = useRef(null);
    const bebidasRef = useRef(null);
    const contenedorRef = useRef(null);
    const headerRef = useRef(null);

    useEffect(() => {
        const unsub = onSnapshot(doc(db, "configuracion", "textos"), (snap) => {
            if (snap.exists()) setTextos(snap.data());
        });
        return () => unsub();
    }, []);

    const rutasMenu = ["/cono-gratis", "/danos-tu-opinion", "/pagina-misteriosa"];

    const seleccion =
        rutasMenu.includes(location.pathname)
            ? null
            : location.pathname === "/comidas" || location.pathname === "/"
                ? "comidas"
                : location.pathname === "/helados"
                    ? "helados"
                    : location.pathname === "/bebidas"
                        ? "bebidas"
                        : null;

    useEffect(() => {
        let ref = null;
        if (seleccion === "comidas") ref = comidasRef.current;
        else if (seleccion === "helados") ref = heladosRef.current;
        else if (seleccion === "bebidas") ref = bebidasRef.current;

        if (ref && contenedorRef.current) {
            const rect = ref.getBoundingClientRect();
            const contRect = contenedorRef.current.getBoundingClientRect();
            setPos({ left: rect.left - contRect.left, width: rect.width });
        }
    }, [seleccion]);

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    return (
        <>
            <Helmet>
                <title>Toppings - Comidas, Helados y Bebidas</title>
                <meta name="description" content="Barra de navegación de Toppings. Accede rápidamente a Comidas, Helados y Bebidas con imágenes y descripciones optimizadas." />
                <meta name="keywords" content="Toppings, comida, helados, bebidas, menú, postres, refrescos" />
                <meta property="og:title" content="Toppings - Comidas, Helados y Bebidas" />
                <meta property="og:description" content="Barra de navegación principal de Toppings. Accede rápidamente a Comidas, Helados y Bebidas." />
                <meta property="og:image" content={logo} />
                <meta property="og:type" content="website" />
                <meta name="twitter:title" content="Toppings - Comidas, Helados y Bebidas" />
                <meta name="twitter:description" content="Barra de navegación principal de Toppings. Accede rápidamente a Comidas, Helados y Bebidas." />
                <meta name="twitter:image" content={logo} />
                <meta name="twitter:card" content="summary_large_image" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            { "@type": "ListItem", "position": 1, "name": "Inicio", "item": `${window.location.origin}/` },
                            { "@type": "ListItem", "position": 2, "name": "Comidas", "item": `${window.location.origin}/comidas` },
                            { "@type": "ListItem", "position": 3, "name": "Helados", "item": `${window.location.origin}/helados` },
                            { "@type": "ListItem", "position": 4, "name": "Bebidas", "item": `${window.location.origin}/bebidas` }
                        ]
                    })}
                </script>
            </Helmet>

            <Grid
                ref={headerRef}
                container
                justifyContent="center"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 12 }}
                sx={{
                    position: "fixed",
                    width: "100%",
                    backgroundColor: "rgba(255, 255, 255, 0.3)",
                    backdropFilter: "blur(30px)",
                    WebkitBackdropFilter: "blur(10px)",
                    top: 0,
                    zIndex: 1300,
                    py: 1,
                    px: 1,
                    borderBottom: "1px solid black",
                }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    size={{ xs: 12, sm: 12, md: 12 }}
                    sx={{ maxWidth: "1400px", px: 3, pt: 0, gap: 2 }}
                >
                    <Grid container justifyContent="center">
                        <a href="https://linktr.ee/Toppings.col" style={{ textDecoration: "none" }}>
                            <div style={{ width: 80, height: 80, borderRadius: "50%", backgroundColor: "transparent", display: "flex", alignItems: "center", justifyContent: "center", transition: "background-color 0.3s ease" }}>
                                <img src={logo} alt="Toppings Logo" style={{ width: 77, height: 77, borderRadius: "50%", cursor: "pointer" }} />
                            </div>
                        </a>
                    </Grid>

                    <Grid
                        ref={contenedorRef}
                        container
                        justifyContent="center"
                        alignItems="center"
                        sx={{ position: "relative", maxWidth: "700px", borderRadius: "50px", overflow: "hidden", backgroundColor: "#FFA602", px: 0, py: 0, gap: 6 }}
                    >
                        {seleccion && (
                            <div style={{ position: "absolute", top: 5.5, left: pos.left + 8, width: pos.width - 16, height: "calc(100% - 11px)", backgroundColor: "#C16D00", borderRadius: "50px", transition: "all 0.5s cubic-bezier(0.77, 0, 0.175, 1)", zIndex: 0 }} />
                        )}

                        <Grid ref={comidasRef} item xs component={Link} to="/comidas" aria-label="Ir a Comidas" sx={{ color: "white", textAlign: "center", py: 1, px: 4, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", position: "relative", zIndex: 1, textDecoration: "none", fontFamily: 'Poppins' }}>
                            <LunchDiningRoundedIcon fontSize="large" />
                            <Typography sx={{ fontSize: 16, fontWeight: 100, fontFamily: 'Poppins' }}>Comidas</Typography>
                        </Grid>

                        <Grid ref={heladosRef} item xs component={Link} to="/helados" aria-label="Ir a Helados" sx={{ color: "white", textAlign: "center", py: 1, px: 4, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", position: "relative", zIndex: 1, textDecoration: "none" }}>
                            <IcecreamRoundedIcon fontSize="large" />
                            <Typography sx={{ fontSize: 16, fontWeight: 100 }}>Helados</Typography>
                        </Grid>

                        <Grid ref={bebidasRef} item xs component={Link} to="/bebidas" aria-label="Ir a Bebidas" sx={{ color: "white", textAlign: "center", py: 1, px: 4, cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", position: "relative", zIndex: 1, textDecoration: "none" }}>
                            <LocalBarRoundedIcon fontSize="large" />
                            <Typography sx={{ fontSize: 16, fontWeight: 100 }}>Bebidas</Typography>
                        </Grid>
                    </Grid>

                    <Grid item>
                        <IconButton onClick={handleMenuOpen} sx={{ backgroundColor: "#FFA602", width: 70, height: 70, borderRadius: "50%", "&:hover": { backgroundColor: "#C16D00" } }}>
                            <MoreHorizIcon sx={{ color: "white", fontSize: 35 }} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            PaperProps={{ sx: { borderRadius: "12px", mt: 1, boxShadow: "0px 4px 12px rgba(0,0,0,0.15)" } }}
                        >
                            <MenuItem onClick={handleMenuClose} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Link to="/cono-gratis" style={{ textDecoration: "none", color: "black" }}>
                                    <Typography sx={{ fontSize: 16, fontWeight: 300 }}>
                                        {textos.barra_pc_menu || "Reclama un helado gratis"}
                                    </Typography>
                                </Link>
                                <SentimentVerySatisfiedOutlinedIcon sx={{ ml: 2, fontSize: 20 }} />
                            </MenuItem>
                        </Menu>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default BarraPc;